<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <pb-body-base :busy="busy">
        <template v-slot:default="props">
            <pb-body banner-size="sm"
                     :banner-img="fileResourceUrl(bannerImage)"
                     :breadcrumbs="breadcrumbs"
                     page-title="ABOUT">
                <template slot="body">
                    <b-container>
                        <b-row>
                            <b-col class="p-0 m-0">
                                <grid-layout
                                        :layout.sync="layout"
                                        :col-num="12"
                                        :row-height="250"
                                        :is-draggable="false"
                                        :is-resizable="false"
                                        :is-mirrored="false"
                                        :responsive="true"
                                        :vertical-compact="true"
                                        :margin="[0, 0]"
                                        :use-css-transforms="true">
                                    <grid-item v-bind:key="index" v-for="(item, index) in layout"
                                               :x="item.x"
                                               :y="item.y"
                                               :w="item.w"
                                               :h="item.h"
                                               :i="item.i">
                                        <div class="about-box" v-if="item.type === 1">

                                            <b-row no-gutters class="h-50 overflow-hidden">
                                                <b-col>
                                                    <img :src="fileResourceUrl(item.content.image)" :alt="item.content.image" />
                                                </b-col>
                                            </b-row>
                                            <b-row no-gutters class="h-50 overflow-hidden">

                                                <b-col v-html="item.content.text" class="text-center p-4">
                                                </b-col>
                                            </b-row>
                                        </div>
                                        <div class="about-box" v-if="item.type === 2">
                                            <b-row no-gutters class="h-100">
                                                <b-col class="h-100">
                                                    <img :src="fileResourceUrl(item.content.image)" :alt="item.content.image"/>
                                                </b-col>
                                                <b-col v-html="item.content.text" class="text-center p-4 h-100">
                                                </b-col>
                                            </b-row>
                                        </div>
                                        <div class="about-box" v-if="item.type === 3">
                                            <b-row no-gutters class="overflow-hidden h-100">
                                                <b-col v-html="item.content.text" class="text-center p-4 h-100">
                                                </b-col>
                                                <b-col class="h-100">
                                                    <img :src="fileResourceUrl(item.content.image)" :alt="item.content.image"/>
                                                </b-col>
                                            </b-row>
                                        </div>
                                       <div class="about-box" v-if="item.type === 4">
                                          <b-row no-gutters class="overflow-hidden h-100">
                                             <b-col v-html="item.content.text" class="text-center p-4 h-100">
                                             </b-col>
                                          </b-row>
                                       </div>
                                    </grid-item>
                                </grid-layout>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
            </pb-body>
        </template>
    </pb-body-base>
</template>


<script>

    import * as VueGridLayout from "vue-grid-layout";
    import ContentAPI from "@shared/_api/cms/content";

    export default {
        name: 'pb-about',
        components: {
            GridLayout: VueGridLayout.GridLayout,
            GridItem: VueGridLayout.GridItem
        },
        mounted() {
            this.busy = true;
            ContentAPI.fetchPageByName("about").then(result => {
                this.bannerImage = result.contentDataSet.banner.value;
                this.layout = [
                    {
                        "x": 0,
                        "y": 0,
                        "w": 8,
                        "h": 2,
                        "i": "0",
                        content: {
                            text: result.contentDataSet.Kachel1Text.value
                        },
                        type: 4
                    },
                    {
                        "x": 8,
                        "y": 0,
                        "w": 4,
                        "h": 2,
                        "i": "1",
                        content: {
                            text: result.contentDataSet.Kachel2Text.value
                        },
                        type: 4
                    },
                    {
                        "x": 0,
                        "y": 2,
                        "w": 4,
                        "h": 2,
                        "i": "2",
                        content: {
                            text: result.contentDataSet.Kachel3Text.value,
                            image: result.contentDataSet.Kachel3Bild.value
                        },
                        type: 1
                    },
                    {
                        "x": 4,
                        "y": 2,
                        "w": 4,
                        "h": 2,
                        "i": "3",
                        content: {
                            text: result.contentDataSet.Kachel4Text.value,
                            image: result.contentDataSet.Kachel4Bild.value
                        },
                        type: 1
                    },
                    {
                        "x": 8,
                        "y": 2,
                        "w": 4,
                        "h": 3,
                        "i": "4",
                        content: {
                            text: result.contentDataSet.Kachel5Text.value,
                            image: result.contentDataSet.Kachel5Bild.value
                        },
                        type: 1
                    },
                    {
                        "x": 0,
                        "y": 3,
                        "w": 8,
                        "h": 1,
                        "i": "5",
                        content: {
                            text: result.contentDataSet.Kachel6Text.value,
                            image: result.contentDataSet.Kachel6Bild.value
                        },
                        type: 2
                    },
                    {
                        "x": 0,
                        "y": 4,
                        "w": 12,
                        "h": 1,
                        "i": "6",
                        content: {
                            text: result.contentDataSet.Kachel7Text.value,
                            image: result.contentDataSet.Kachel7Bild.value
                        },
                        type: 3
                    },
                ]
            }).finally(() => {
                this.busy = false
            });
        },
        data: function () {
            return {
                breadcrumbs: [{
                    text: "About",
                    href: '/about'
                }],
                layout: [],
                bannerImage: "",
                busy: false

            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

    .vue-grid-item.no-touch { touch-action: auto; }

    .vue-grid-item {
        padding: 10px;

        .about-box {
            height: 100%;
            width: 100%;
            background: #F1F1F1;

            img {
                object-fit: cover;
                width: 100%;
                height: 100%;
            }
        }
    }


</style>
